import React from "react"
import { motion } from "motion/react"

import { ReactComponent as GreenFile } from "../assets/green-file.svg"
import { ReactComponent as GreenFolder } from "../assets/green-folder.svg"
import CertExample from "../assets/cert-example.png"
import { Box } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import CertPreview, { PDF_ASPECT_RATIO } from "./CertPreview"

export const CertFolderAnimation = ({
	color1 = '#8CF4DC',
	color2 = '#CCFAF0',
	shadows = [
		"0 0 4px 0 rgba(2, 176, 195, 0.4)",
		"0 0 25px 0 rgba(2, 176, 195, 0.8)",
		"0 0 4px 0 rgba(2, 176, 195, 0.4)"
	],
	previewImage = CertExample,
	width = '100%',
}) => {
	const size = width
	const viewPort = {
		once: true,
		amount: 0.8
	}

	return (
		<div style={{
			width: '100%',
			marginTop: 10,
			display: 'flex',
			flexDirection: 'column',
			gap: 10,
			position: 'relative',
		}}>
			<motion.div
				initial={{ x: 0, opacity: 0.1, width: '100%' }}
				whileInView={{ x: 0, opacity: 1 }}
				viewport={viewPort}
				transition={{
					duration: 0.5,
					ease: "easeOut"
				}}
			>
				<Box
					mr={{ base: 0, md: 20 }}
					ml={{ base: 30, md: 80 }}
					style={{
						marginTop: 10,
						display: 'flex',
						flexDirection: 'column',
						gap: 10,
						position: 'relative',
					}}>

					{/* green folder */}
					<motion.div
						initial={{ x: -20, rotate: -4 }}
						whileInView={{ x: -20, rotate: -8 }}
						transition={{
							duration: 0.5,
						}}
						viewport={viewPort}
						style={{ transformOrigin: "bottom left" }}
					>
						<GreenFolder
							fill='white'
							color={color1}
							width={size}
							height={'auto'}
						/>
					</motion.div>

					{/* green file */}
					<motion.div
						initial={{ x: -10, rotate: -3, width: '100%' }}
						whileInView={{ x: -10, rotate: -4 }}
						transition={{
							duration: 0.5,
							repeat: 0,
						}}
						viewport={viewPort}
						style={{
							position: 'absolute',
							top: 15,
							left: 0,
							transformOrigin: "bottom left"
						}}
					>
						<GreenFile
							width={size}
							height={'auto'}
							color={color2}
						/>
					</motion.div>

					{/* main cert image */}
					<motion.div
						style={{
							aspectRatio: PDF_ASPECT_RATIO,
							width: size,
							position: 'absolute',
							top: 20,
							left: 0,
							transformOrigin: "bottom left",
							overflow: 'hidden'
						}}
						initial={{ x: 0, rotate: -4 }}
						whileInView={{ x: 0, rotate: 0 }}
						animate={{
							boxShadow: shadows
						}}
						transition={{
							rotate: { duration: 0.5 },
							boxShadow: {
								duration: 1.5,
								repeat: Infinity,
								repeatType: "reverse"
							}
						}}
						viewport={viewPort}
					>

						{/* <img
						style={{
							width: '100%',
							height: '100%',
							objectFit: 'cover'
						}}
						src={previewImage}
						alt="Certificate preview"
					/> */}
						<CertPreview
							src={previewImage}
							width={'100%'}
						/>
						{/* shimmering effect */}
						<motion.div
							viewport={viewPort}
							animate={{
								backgroundPosition: ["-200% 0", "200% 0", "200% 0"]
							}}
							transition={{
								duration: 5,
								delay: 0.5,
								repeat: 0,
								repeatType: "loop"
							}}
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
								background: 'linear-gradient(135deg, transparent 0%, transparent 50%, rgba(255, 255, 255, 0.8) 55%, transparent 65%)',
								backgroundSize: '200% 100%',
								zIndex: 10
							}}
						/>
					</motion.div>
				</Box>
			</motion.div>
		</div>


	)
}